/* eslint-disable */
window.indexedDBlist = {};
window.isdebugIndexedDB = false;
export default {
    // indexedDB兼容
    indexedDB: window.indexedDB || window.webkitindexedDB || window.msIndexedDB || window.mozIndexedDB,

    openDB: function (dbName, dbTableName, dbVersion = '') {   //dbVersion不能有默认值
        return new Promise((resolve, reject) => {
            if (window.indexedDBlist[dbName]) {
                let db = window.indexedDBlist[dbName];
                if (!db.objectStoreNames.contains(dbTableName)) {   //数据库连接中，没有这个表，关闭这个连接，重新打开
                    db.close();
                    if (dbVersion <= db.version) {
                        this.log('当前连接版本' + db.version);
                        dbVersion = db.version + 1;
                    }
                    delete window.indexedDBlist[dbName];
                    this.log('缓存数据库连接中没有表' + dbTableName + ',关闭重新打开,版本' + dbVersion);
                } else {
                    this.log('返回缓存链接' + dbName);
                    resolve(window.indexedDBlist[dbName]);
                    return;
                }
            }

            let request;
            if (dbVersion) {
                request = this.indexedDB.open(dbName, dbVersion); this.log('打开数据库' + dbName + ',版本号' + dbVersion);
            } else {
                request = this.indexedDB.open(dbName); this.log('打开数据库' + dbName);
            }

            let timer = setTimeout(() => {
                reject('打开indexDB超时!')
            }, 1000 * 2)

            request.onerror = (event) => {
                if (timer) clearTimeout(timer);
                reject("IndexedDB数据库打开错误，一般是版本号太低了" + JSON.stringify(event));
            };
            request.onsuccess = (event) => {  //dbVersion
                if (timer) clearTimeout(timer);
                let db = event.target.result; this.log('版本号' + db.version);
                window.indexedDBlist[dbName] = db;
                resolve(event.target.result);
            };
            request.onclose = (event) => {
                this.log('=====', event);
            };
            request.onupgradeneeded = (event) => {
                var db = event.target.result; this.log(event);
                if (!db.objectStoreNames.contains(dbTableName)) {
                    db.createObjectStore(dbTableName, { keyPath: 'id' });
                }

                if (db.name == 'netlog') {   //netlog中只保留当天的数据
                    let list = db.objectStoreNames;
                    for (let index = 0; index < list.length; index++) {
                        const table = list[index];
                        if (table == new Date().format('yyyyMMdd')) continue;
                        db.deleteObjectStore(table);
                    }
                }
            }
        });
    },
    // 更新
    put: function (dbName, tableName, key, value) {
        return new Promise(async (resolve, reject) => {
            try {
                let db = await this.openDB(dbName, tableName);

                if (!db.objectStoreNames.contains(tableName)) {
                    this.log('打开失败,重试一次');
                    db = await this.openDB(dbName, tableName);
                    if (!db.objectStoreNames.contains(tableName)) throw '表(' + tableName + ')不存在!';
                }

                let request = db
                    .transaction(tableName, "readwrite")
                    .objectStore(tableName)
                    .put({ id: key, value: value, time: new Date().getTime() });

                request.onerror = function (error) {
                    this.log('---', error);
                    resolve(false);
                };
                request.onsuccess = function () {
                    resolve(true);
                };

            } catch (error) {
                reject(error);
            }
        });
    },
    // 删除数据
    delete: function (dbName, tableName, keyValue) {
        return new Promise(async (resolve, reject) => {
            try {
                let db = await this.openDB(dbName, tableName);
                if (!db.objectStoreNames.contains(tableName)) {
                    this.log('打开失败,重试一次');
                    db = await this.openDB(dbName, tableName);
                    if (!db.objectStoreNames.contains(tableName)) throw '表(' + tableName + ')不存在!';
                }

                let request = db
                    .transaction(tableName, "readwrite")
                    .objectStore(tableName)
                    .delete(keyValue);

                request.onerror = function () {
                    resolve(false);
                };
                request.onsuccess = function () {
                    resolve(true);
                };
            } catch (error) {
                reject(error);
            }
        });
    },
    // 清空数据
    clear: async function (dbName, tableName) {
        let db = await this.openDB(dbName, tableName);
        if (!db.objectStoreNames.contains(tableName)) {
            this.log('打开失败,重试一次');
            db = await this.openDB(dbName, tableName);
            if (!db.objectStoreNames.contains(tableName)) throw '表(' + tableName + ')不存在!';
        }

        if (!db.objectStoreNames.contains(tableName)) {
            db.createObjectStore(tableName, { keyPath: 'id' });
        }

        let store = db.transaction(tableName, "readwrite").objectStore(tableName);
        store.clear();
    },
    // 查询数据 表名 索引值 索引 key  没有value key为key 而不是索引
    get: function (dbName, tableName, key) {
        return new Promise(async (resolve, reject) => {
            try {
                let db = await this.openDB(dbName, tableName);
                if (!db.objectStoreNames.contains(tableName)) {
                    this.log('打开失败,重试一次');
                    db = await this.openDB(dbName, tableName);
                    if (!db.objectStoreNames.contains(tableName)) throw '表(' + tableName + ')不存在!';
                }

                let request = db
                    .transaction(tableName, "readonly")
                    .objectStore(tableName).get(key);

                request.onerror = function () {
                    reject("查询数据失败");
                };
                request.onsuccess = function (event) {
                    let value = (event.target.result || {}).value;
                    if (typeof value == 'undefined') resolve(null);
                    else resolve(value);
                };
            } catch (error) {
                reject(error);
            }
        });
    },
    list: function (dbName, tableName) {
        return new Promise(async (resolve, reject) => {
            try {
                let db = await this.openDB(dbName, tableName);
                if (!db.objectStoreNames.contains(tableName)) {
                    this.log('打开失败,重试一次');
                    db = await this.openDB(dbName, tableName);
                    if (!db.objectStoreNames.contains(tableName)) throw '表(' + tableName + ')不存在!';
                }

                let request = db
                    .transaction(tableName, "readonly")
                    .objectStore(tableName).openCursor();

                request.onerror = function () {
                    reject("查询数据失败");
                };
                let data = [];
                request.onsuccess = function (event) {
                    // let value = (event.target.result || {}).value;
                    // if (typeof value == 'undefined') reject("key(" + key + ")不存在");
                    // else resolve(value);

                    if (event.target.result) {
                        data.push(event.target.result.value);
                        event.target.result.continue();
                    } else {
                        resolve(data);
                    }
                };
            } catch (error) {
                reject(error);
            }
        });
    },

    getAsync: async function (dbName, tableName, key) {
        let tmp = '';
        try {
            tmp = await this.get(dbName, tableName, key);
        } catch (error) {
            console.log(error);
        }
        return tmp;
    },
    putAsync: async function (dbName, tableName, key, value) {
        try {
            await this.put(dbName, tableName, key, value);
        } catch (error) {
            console.log(error);
        }
    },

    log: function (...args) {
        if (window.isdebugIndexedDB) console.log(...args);
    },
};